import PropTypes from 'prop-types';
import { Tween } from 'react-gsap';
import Image from '../../image';
import Section from '../Section.jsx';
import styles from './SectionIntro.module.scss';

function SectionIntro({ zIndex, debug, showTitlesOnSide, isLast }) {
  return (
    <Section zIndex={zIndex} debug={debug} isLast={isLast} showTitlesOnSide={showTitlesOnSide} scrub className={styles.section}>
      <div className={styles.container}>
        <Tween from={{ scale: 1.5 }} to={{ scale: 1 }}>
          <div><Image src="leah-dou/text/title.svg" className={styles.title} /></div>
        </Tween>
        <Image src="leah-dou/text/subtitle.svg" className={styles.title} />

        <Tween from={{ opacity: 0 }} to={{ opacity: 1 }}>
          <p className={styles.text}>
            「穿越時光的音符，回憶的旋律。在今期封面故事中，我們將與竇靖童一起展開一場關於音樂與回憶的深刻之旅。透過她的歌單，跟隨著她的腳步，聆聽那些陪伴她成長的旋律，重溫那些特別的時刻。讓我們一同感受音樂的魔力，重新連結我們的青春和回憶。」
            <br /><br />
          </p>
          <div className={styles.credit}>
            Interview by Oscar Law<br />
            Photography by Bensonviews
          </div>
        </Tween>
      </div>
    </Section>
  );
}

SectionIntro.propTypes = {
  zIndex: PropTypes.number,
  debug: PropTypes.bool,
  showTitlesOnSide: PropTypes.bool,
  isLast: PropTypes.bool,
};

export default SectionIntro;
